// pages/index.tsx
import React from "react"
import { Header } from "../../components/Header"
import { Hero } from "../../components/Hero"
import { About } from "../../components/About"
import { Services } from "../../components/Services"
import { Contact } from "../../components/Contact"
import { TopBar } from "../../components/TopBar"
import { CookieConsent } from "../../components/CookieConsent"

const Home: React.FC = () => {
	return (
		<div>
			<TopBar />
			<Header />
			<Hero />
			<CookieConsent />
			<About />
			<Services />
			<Contact />
		</div>
	)
}

export default Home
